type FieldDetails = {
  type: string;
  items?: {
    type: string;
    format?: string;
  };
};

export const fieldConfigurationsRaw = {
  '@timestamp': {
    type: 'date-time',
  },
  '@type': {
    type: 'string',
  },
  'ad.event.auth.logon_type': {
    type: 'uint8',
  },
  'ad.event.code': {
    type: 'string',
  },
  'ad.event.origin.username': {
    type: 'string',
  },
  'ad.event.title': {
    type: 'string',
  },
  'auth.type': {
    type: 'string',
  },
  'client.address': {
    type: 'string',
  },
  'client.as.number': {
    type: 'uint32',
  },
  'client.bytes': {
    type: 'int64',
  },
  'client.domain': {
    type: 'string',
  },
  'client.geo.city_name': {
    type: 'string',
  },
  'client.geo.country_iso_code': {
    type: 'string',
  },
  'client.geo.country_name': {
    type: 'string',
  },
  'client.geo.region_name': {
    type: 'string',
  },
  'client.ip': {
    type: 'ip',
  },
  'client.ip_classification': {
    type: 'string',
  },
  'client.packets': {
    type: 'int64',
  },
  'client.port': {
    type: 'uint16',
  },
  'client.user.email': {
    type: 'string',
  },
  'client.user.full_name': {
    type: 'string',
  },
  'client.user.id': {
    type: 'string',
  },
  'client.user.name': {
    type: 'string',
  },
  'client.user.username': {
    type: 'string',
  },
  'client.whois.registrant.organization': {
    type: 'string',
  },
  'cloud.client.geo.city_name': {
    type: 'string',
  },
  'cloud.client.geo.country_name': {
    type: 'string',
  },
  'cloud.client.user.name': {
    type: 'string',
  },
  'cloud.event.name': {
    type: 'string',
  },
  'cloud.region': {
    type: 'string',
  },
  'cloud.resource.name': {
    type: 'string',
  },
  'cloud.resource.path': {
    type: 'string',
  },
  'cloud.service.event.severity': {
    type: 'string',
  },
  'cloud.service.name': {
    type: 'string',
  },
  'dns.answers.class': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'dns.answers.data': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'dns.answers.ttl': {
    type: 'int64',
    items: {
      type: 'integer',
      format: 'int64',
    },
  },
  'dns.answers.type': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'dns.question.class': {
    type: 'string',
  },
  'dns.question.names': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'dns.question.type': {
    type: 'string',
  },
  'dns.question.whois.registrant.organization': {
    type: 'string',
  },
  'dns.resolved_ip': {
    type: 'array',
    items: {
      type: 'string',
      format: 'ip',
    },
  },
  'dns.response_code': {
    type: 'string',
  },
  'event.action': {
    type: 'string',
  },
  'event.category': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'event.code': {
    type: 'string',
  },
  'event.dataset': {
    type: 'string',
  },
  'event.duration': {
    type: 'int64',
  },
  'event.end': {
    type: 'date-time',
  },
  'event.kind': {
    type: 'string',
  },
  'event.module': {
    type: 'string',
  },
  'event.outcome': {
    type: 'string',
  },
  'event.provider': {
    type: 'string',
  },
  'event.reason': {
    type: 'string',
  },
  'event.severity': {
    type: 'uint8',
  },
  'event.start': {
    type: 'date-time',
  },
  'event.type': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'event.uuid': {
    type: 'string',
  },
  'file.directory': {
    type: 'string',
  },
  'file.hash.md5': {
    type: 'string',
  },
  'file.hash.sha1': {
    type: 'string',
  },
  'file.hash.sha256': {
    type: 'string',
  },
  'file.mime_type': {
    type: 'string',
  },
  'file.name': {
    type: 'string',
  },
  'file.path': {
    type: 'string',
  },
  'firewall.class': {
    type: 'string',
  },
  'firewall.client': {
    type: 'string',
  },
  'firewall.connection_id': {
    type: 'string',
  },
  'firewall.device.name': {
    type: 'string',
  },
  'firewall.event': {
    type: 'string',
  },
  'firewall.event_type': {
    type: 'string',
  },
  'firewall.info': {
    type: 'string',
  },
  'firewall.message': {
    type: 'string',
  },
  'firewall.message_id': {
    type: 'string',
  },
  'firewall.policy': {
    type: 'string',
  },
  'firewall.rule': {
    type: 'string',
  },
  'firewall.severity': {
    type: 'string',
  },
  'firewall.sinkhole': {
    type: 'string',
  },
  'host.class': {
    type: 'string',
  },
  'host.domain': {
    type: 'string',
  },
  'host.external_ip': {
    type: 'ip',
  },
  'host.geo.city_name': {
    type: 'string',
  },
  'host.geo.country_iso_code': {
    type: 'string',
  },
  'host.geo.country_name': {
    type: 'string',
  },
  'host.hostname': {
    type: 'string',
  },
  'host.ip': {
    type: 'array',
    items: {
      type: 'string',
      format: 'ip',
    },
  },
  'host.name': {
    type: 'string',
  },
  'host.os.family': {
    type: 'string',
  },
  'host.user.email': {
    type: 'string',
  },
  'host.user.full_name': {
    type: 'string',
  },
  'host.user.id': {
    type: 'string',
  },
  'host.user.name': {
    type: 'string',
  },
  'host.user.username': {
    type: 'string',
  },
  'http.request.method': {
    type: 'string',
  },
  'http.request.mime_type': {
    type: 'string',
  },
  'http.response.content_type': {
    type: 'string',
  },
  'http.response.status_code': {
    type: 'uint16',
  },
  'network.application': {
    type: 'string',
  },
  'network.bytes': {
    type: 'int64',
  },
  'network.direction': {
    type: 'string',
  },
  'network.packets': {
    type: 'int64',
  },
  'network.protocol': {
    type: 'string',
  },
  'network.transport': {
    type: 'string',
  },
  'observer.geo.city_name': {
    type: 'string',
  },
  'observer.geo.country_iso_code': {
    type: 'string',
  },
  'observer.geo.country_name': {
    type: 'string',
  },
  'observer.type': {
    type: 'string',
  },
  'organization.deployment.id': {
    type: 'string',
  },
  'organization.id': {
    type: 'string',
  },
  'organization.uuid': {
    type: 'uuid',
  },
  'process.command_line': {
    type: 'string',
  },
  'process.executable': {
    type: 'string',
  },
  'process.hash.md5': {
    type: 'string',
  },
  'process.hash.sha1': {
    type: 'string',
  },
  'process.hash.sha256': {
    type: 'string',
  },
  'process.name': {
    type: 'string',
  },
  'process.parent.command_line': {
    type: 'string',
  },
  'process.parent.executable': {
    type: 'string',
  },
  'process.parent.hash.md5': {
    type: 'string',
  },
  'process.parent.hash.sha1': {
    type: 'string',
  },
  'process.parent.hash.sha256': {
    type: 'string',
  },
  'process.parent.name': {
    type: 'string',
  },
  'process.parent.pid': {
    type: 'uint32',
  },
  'process.parent.ppid': {
    type: 'uint32',
  },
  'process.parent.working_directory': {
    type: 'string',
  },
  'process.pid': {
    type: 'uint32',
  },
  'process.ppid': {
    type: 'uint32',
  },
  'process.working_directory': {
    type: 'string',
  },
  'related.as.number': {
    type: 'array',
    items: {
      type: 'integer',
      format: 'uint32',
    },
  },
  'related.country': {
    type: 'string',
  },
  'related.domain': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.email': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.event_code': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.file_name': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.groups': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.hash': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.hosts': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.ip': {
    type: 'array',
    items: {
      type: 'string',
      format: 'ip',
    },
  },
  'related.ip_address': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.log_source': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.login_status': {
    type: 'string',
  },
  'related.process_name': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.url': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.user': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.whois.registrant.name': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'related.whois.registrant.organization': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'remote.address': {
    type: 'string',
  },
  'remote.domain': {
    type: 'string',
  },
  'remote.ip': {
    type: 'ip',
  },
  'remote.port': {
    type: 'uint16',
  },
  'remote.registered_domain': {
    type: 'string',
  },
  'rule.description': {
    type: 'string',
  },
  'rule.events.category': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'rule.events.description': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'rule.events.identifier': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'rule.priority': {
    type: 'string',
  },
  'rule.subtype': {
    type: 'string',
  },
  'server.address': {
    type: 'string',
  },
  'server.as.number': {
    type: 'uint32',
  },
  'server.as.organization.name': {
    type: 'string',
  },
  'server.bytes': {
    type: 'int64',
  },
  'server.domain': {
    type: 'string',
  },
  'server.geo.city_name': {
    type: 'string',
  },
  'server.geo.country_iso_code': {
    type: 'string',
  },
  'server.geo.country_name': {
    type: 'string',
  },
  'server.ip': {
    type: 'ip',
  },
  'server.ip_classification': {
    type: 'string',
  },
  'server.packets': {
    type: 'int64',
  },
  'server.port': {
    type: 'uint16',
  },
  'server.user.email': {
    type: 'string',
  },
  'server.user.full_name': {
    type: 'string',
  },
  'server.user.id': {
    type: 'string',
  },
  'server.user.name': {
    type: 'string',
  },
  'server.user.username': {
    type: 'string',
  },
  'server.whois.registrant.organization': {
    type: 'string',
  },
  'service.name': {
    type: 'string',
  },
  tags: {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'threat.severity': {
    type: 'uint8',
  },
  'threat.tactic.name': {
    type: 'array',
    items: {
      type: 'string',
    },
  },
  'tls.client.hash.sha256': {
    type: 'string',
  },
  'tls.server.hash.sha256': {
    type: 'string',
  },
  'url.domain': {
    type: 'string',
  },
  'url.full': {
    type: 'string',
  },
  'url.path': {
    type: 'string',
  },
  'url.whois.registrant.organization': {
    type: 'string',
  },
  'user.changes.email': {
    type: 'string',
  },
  'user.changes.full_name': {
    type: 'string',
  },
  'user.changes.id': {
    type: 'string',
  },
  'user.changes.name': {
    type: 'string',
  },
  'user.changes.username': {
    type: 'string',
  },
  'user.effective.email': {
    type: 'string',
  },
  'user.effective.full_name': {
    type: 'string',
  },
  'user.effective.id': {
    type: 'string',
  },
  'user.effective.name': {
    type: 'string',
  },
  'user.effective.username': {
    type: 'string',
  },
  'user.email': {
    type: 'string',
  },
  'user.full_name': {
    type: 'string',
  },
  'user.id': {
    type: 'string',
  },
  'user.name': {
    type: 'string',
  },
  'user.target.email': {
    type: 'string',
  },
  'user.target.full_name': {
    type: 'string',
  },
  'user.target.id': {
    type: 'string',
  },
  'user.target.name': {
    type: 'string',
  },
  'user.target.username': {
    type: 'string',
  },
  'user.username': {
    type: 'string',
  },
  'user_agent.description': {
    type: 'string',
  },
  'user_agent.original': {
    type: 'string',
  },
};

const fieldConfigurations: { [key: string]: FieldDetails } =
  fieldConfigurationsRaw;

export type GetFieldsOptions = {
  omit?: {
    related?: boolean;
    types?: string[];
  };
};

export type EventLogField = keyof typeof fieldConfigurationsRaw;

// filters out related and date-time fields by default
export const getFieldConfigurations = (
  options: GetFieldsOptions = {
    omit: { related: true, types: ['date-time'] },
  },
) => {
  const filterRelated = (key: string) => {
    if (options?.omit?.related) {
      return !key.startsWith('related');
    }
    return true;
  };

  const filterByType = (key: string) => {
    if (!options?.omit?.types) return true;

    for (const type of options.omit.types) {
      if (
        fieldConfigurations[key].type === type ||
        fieldConfigurations[key].items?.type === type
      ) {
        return false;
      }
    }
    return true;
  };

  return [...Object.keys(fieldConfigurations)]
    .filter(filterRelated)
    .filter(filterByType)
    .reduce<typeof fieldConfigurations>((acc, key) => {
      acc[key] = fieldConfigurations[key];
      return acc;
    }, {});
};

export const fields = Object.keys(fieldConfigurations);

export const internalFieldConfigurations: { [key: string]: FieldDetails } = {
  'evidence_task.ticket_template': { type: 'string' },
  'evidence_task.ticket_id': { type: 'string' },
};

export const internalFields = Object.keys(internalFieldConfigurations);

export const getAllFieldConfigurations = () => {
  return { ...getFieldConfigurations(), ...internalFieldConfigurations };
};

export const isEventLogField = (value: string): value is EventLogField => {
  return Boolean(fields.includes(value as EventLogField));
};
